import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
// import { fetchPolicyHolderInfo, loadingUser } from '../action';
import { Button, Grid, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { fetchHealthFacilities, loadingUser } from "../../action";
import { useConvention } from "../../hooks/useConvention";
import "../../styles/theme.scss";
import { CLAIM_FORM } from "../../utils/constant";
import ClaimFIlter from "./ClaimFIlter";
import ClaimTable from "./ClaimTable";

function ClaimTab() {
  const token = localStorage.getItem("token");
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [insureeCheck, setInsureeCheck] = useState(false);
  const [policyHolderId, setPolicyHolderId] = useState();
  const [filter, setFilter] = useState([]);
  const userData = useSelector((state) => state.profileReducer);
  const hanldeClaimScreen = () => {
    navigate(CLAIM_FORM);
  };

  useEffect(() => {
    dispatch(loadingUser(token));
  }, []);

  useEffect(() => {
    if (userData?.currentUserResponseData?.i_user?.health_facility_id) {
      dispatch(
        fetchHealthFacilities(
          userData?.currentUserResponseData?.i_user?.health_facility_id
        )
      );
    }
  }, [userData]);

  const { isConventionnementActive } = useConvention();

  return (
    <Grid container>
      <Grid container display="flex" justifyContent="space-between">
        <Typography
          style={{
            fontSize: "24px",
            fontWeight: "bold",
            color: "#000",
            marginLeft: "20px",
          }}
        >
          {t("claimTitle")}
        </Typography>
        <Grid style={{ marginRight: "20px" }}>
          <Button
            onClick={hanldeClaimScreen}
            variant="outlined"
            component="span"
            color="primary"
            disabled={!isConventionnementActive}
            // startIcon={<SaveAltRoundedIcon />}
            style={{ marginLeft: ".5rem" }}
          >
            {t("CreateanewClaim")}
          </Button>
        </Grid>
      </Grid>

      <ClaimFIlter
        policyHolderId={policyHolderId}
        setFilter={setFilter}
        filter={filter}
      />

      <ClaimTable
        policyHolderId={policyHolderId}
        filter={filter}
        insureeCheck={insureeCheck}
      />
    </Grid>
  );
}

export default ClaimTab;
